import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { environment } from '@environments/environment';
import { TeamEquipmentService, TeamLineUpService } from '../../services';
import { SkeletonTeamLineupComponent } from '@/app/components/shared/skeleton/skeleton-team-lineup/skeleton-team-lineup.component';
import { NoResultComponent } from '@/app/components/shared/no-result/no-result.component';
import { TranslationService } from '@/app/services/translation.service';
import { ELanguage } from '@/app/utils';

@Component({
  selector: 'app-equipment-lineup',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NzGridModule,
    SkeletonTeamLineupComponent,
    NoResultComponent,
  ],
  templateUrl: './equipment-lineup.component.html',
})
export class LineupComponent {
  private teamLineUpService = inject(TeamLineUpService);
  private translationService = inject(TranslationService);

  lineUpStatus = computed(() => ({
    isLoading: this.teamLineUpService.isLoadingTeamLineUp(),
    isError: this.teamLineUpService.isErrorTeamLineUp(),
  }));

  teamLineUp = computed(() => this.teamLineUpService.teamLineUp());

  teamId = input<string>('');

  urlSVG = environment.urlIcon;
  urlImg = environment.urlIMG;

  ngOnInit() {
    this.teamLineUpService.getTeamLineUp(this.teamId());
  }

  getPlayerName(
    traslateName: Partial<Record<ELanguage, string>>,
    name: string
  ) {
    return this.translationService.getTraduccionName(traslateName, name);
  }
}
